<template>
  <b-container>
    <h1>Cadastro da empresa: {{ form.razaoSocial }}</h1>
    <!-- <SuccessFadeAlert v-bind:show="sucesso" msg='Registro cadastrado com sucesso' /> -->
    <SuccessFadeAlert ref="alert" msg="Registro cadastrado com sucesso" />

    <b-row v-if="$store.state.adminRms == true" class="mb-3 ml-0">
      <router-link
        :to="'../../systemIntegrationCompany/all/' + form.id.toString()"
      >
        <b-button size="sm">{{
          $t("system.systemIntegration.sidebar")
        }}</b-button>
      </router-link>
      <router-link class="ml-2" :to="'../bi/' + form.id.toString()">
        <b-button size="sm">{{ $t("bi.powerbiview.sidebar") }}</b-button>
      </router-link>
    </b-row>

    <b-form @submit.prevent="processForm">
      <company-crud-data
        :isEditing="true"
        :model="form"
        :modelstate="modelstate"
      >
      </company-crud-data>
      <b-row>
        <b-col>
          <b-button type="submit" :disabled="submitted">Salvar</b-button>
        </b-col>
      </b-row>
    </b-form>

    <!-- {{ $store.state }} -->
    <!-- {{ form }} -->
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";
import CompanyCrudData from "@/components_rms/company/CompanyCrudData.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import CompanyTabs from "@/components_rms/company/CompanyTabs.vue";

export default {
  name: "Create",
  components: {
    CompanyCrudData,
    SuccessFadeAlert,
    CompanyTabs,
  },
  props: {
    id: String,
  },
  data: function () {
    return {
      sucesso: false,
      modelstate: {},
      submitted: false,
      form: {
        mfaRequired: false,
        numeroDocumento: "",
        razaoSocial: "",
        nomeFantasia: "",
        telefoneComercial: "",
        celular: "",
        email: "",
        adminUsername: "",
        adminPassword: "",
        companyTheme: "",
        embarcador: false,
        transportador: false,
        bi: false,
        tracking: false,
        checklist: false,
        planoDeViagem: false,
        mapEngine: 0,
        googleApiKey: "",
        imageQuality: 0,
        compressionLevel: 40,
        allowVideo: false,
        allowDocuments: false,
        allowOcr: false,
        allowInactiveDraftFilter: false,
      },
    };
  },
  directives: {
    mask: AwesomeMask,
  },
  created: function () {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.$apiScheduler
        .get("/empresa/get/" + this.id.toString())
        .then((response) => {
          this.form = response.data;
        })
        .catch((error) => {
          this.form = {};
          console.log(error);
          console.log(error.response.data.errors);

          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    processForm() {
      this.modelstate = {};
      this.submitted = true;
      this.$apiScheduler
        .post("empresa/edit/" + this.id.toString(), this.form)
        .then((response) => {
          this.submitted = false;
          this.sucesso = true;
          this.$refs.alert.show();
          this.form = response.data;
        })
        .catch((error) => {
          this.submitted = false;
          console.log(error);
          console.log(error.response.data.errors);

          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
  },
};
</script>
